import { useSearchParams } from 'react-router-dom';
import SendBackPage from '../SendBack/SendBackPage';
import SelectParcelPage from '../SelectParcel/SelectParcelPage';

export default function SendBackTutorialPage() {
  const [searchParams] = useSearchParams();
  return searchParams.get('type') ? <SendBackPage /> : <SelectParcelPage />;
}
